
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/renegociacao-santander-emprestimos",
      function () {
        return require("private-next-pages/renegociacao-santander-emprestimos.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/renegociacao-santander-emprestimos"])
      });
    }
  